import { useInvitationStoreSelector } from '@/contexts/invitation-context';
import type { BatchAttachmentInfo } from '@fluenceur/types';
import { useEffect } from 'react';

/** Keep prepared fallback body and durable files together while the library loads. */
export function usePreparedInvitationAttachments(attachments?: BatchAttachmentInfo[]) {
  const updateDraft = useInvitationStoreSelector((state) => state.updateEmailAttachmentDraft);
  const isEditorUntouched = useInvitationStoreSelector(
    (state) => !state.messageSnapshot || state.messageSnapshot === state.originalTemplate
  );
  useEffect(() => {
    if (!attachments || !isEditorUntouched) return;
    updateDraft((draft) => {
      if (draft.customized || draft.templateEntryId || draft.uploading || draft.deletingId)
        return draft;
      if (
        draft.attachments.length === attachments.length &&
        draft.attachments.every((file, index) => file.id === attachments[index].id)
      )
        return draft;
      return { ...draft, attachments };
    });
  }, [attachments, isEditorUntouched, updateDraft]);
}
